// src/features/files/upload/useGlobalDropGuard.js
import { useEffect } from 'react';

import { isFileDrag } from './useFileDrop';

/**
 * Stops the browser from opening a file that's dropped outside an upload area,
 * which would navigate away from Orbit. Drop areas call preventDefault
 * themselves, so this only acts on drags nothing else handled.
 * Mount once, at the app root.
 */
export function useGlobalDropGuard() {
  useEffect(() => {
    const onDragOver = (event) => {
      if (!isFileDrag(event) || event.defaultPrevented) return;
      event.preventDefault();
      // Shows the "not allowed" cursor instead of the copy cursor
      event.dataTransfer.dropEffect = 'none';
    };
    const onDrop = (event) => {
      if (isFileDrag(event) && !event.defaultPrevented) event.preventDefault();
    };
    window.addEventListener('dragover', onDragOver);
    window.addEventListener('drop', onDrop);
    return () => {
      window.removeEventListener('dragover', onDragOver);
      window.removeEventListener('drop', onDrop);
    };
  }, []);
}
